/// <reference path="../_references.ts"/>
/// <reference path="../price-guide/price-guide.components.ts"/>

module App.WorkOrder {
    import Appointment = App.Appointments.Appointment;
    import CustomerService = App.Customer.CustomerService;
    import Department = App.Appointments.Department;
    import EditedReturnedProduct = App.PriceGuide.EditedReturnedProduct;
    import FinanceCompany = App.Appointments.FinanceCompany;
    import FinancePlan = App.Appointments.FinancePlan;
    import ItemManagementService = App.ItemManagement.ItemManagementService;
    import OfficeService = App.Utils.OfficeService;
    import OrderChangedEvent = App.NgSortable.OrderChangedEvent;
    import Package = App.PriceGuide.Package;
    import PackagePresetName = App.PriceGuide.PackagePresetName;
    import PackagePresetNote = App.PriceGuide.PackagePresetNote;
    import Product = App.PriceGuide.Product;
    import ProductService = App.PriceGuide.ProductService;
    import ReturnedProduct = App.PriceGuide.ReturnedProduct;
    import SelectedAppointment = App.Appointments.SelectedAppointment;
    import ServiceableItem = App.ItemManagement.ServiceableItem;
    import ServiceableItemCreate = App.ItemManagement.ServiceableItemCreate;
    import ServiceableItemType = App.ItemManagement.ServiceableItemType;
    import ServicePlan = App.Appointments.ServicePlan;
    import ServicePlanAgreement = App.Appointments.ServicePlanAgreement;
    import TitleBarService = App.Helpers.TitleBarService;
    import ToastService = App.Utils.ToastService;
    import Warranty = App.PriceGuide.Warranty;
    import WorkOrderTemplateService = App.WorkOrderTemplate.WorkOrderTemplateService;

    export class WorkOrderController {
        appointment: Appointment = null;
        warranties: Warranty[] = [];
        summary: Summary = null;
        title: string = '';

        canEditProducts: boolean;
        inEditMode: boolean = false;
        isSaving: boolean = false;
        packageAction: string = '';
        fromOffice: boolean = false;

        inArchivedMode: boolean = false;
        archivedPackages?: Package[] = null;
        pendingArchivedPackages: Package[] = [];
        pendingRestores: {[key: number]: boolean} = {};
        originalArchivedIndecies: {[key: number]: number} = {};
        isArchivedLoading: boolean = false;

        bannerOptions: boolean = false;
        bannerPackage: Package = null;

        financePlanLoading: boolean = false;

        isShowingEmail: boolean = false;
        editEmailFlyout: boolean = false;
        showNewEmail: boolean = false;
        newEmail: string = '';
        isApporvalLoaded: boolean = false;

        editEtc: boolean = false;
        estimatedTime: string = '';
        estimatedEndTime: string = '';

        editAdjustments: boolean = false;
        adjustmentCode: string = '';

        editSalesTax: boolean = false;
        salesTaxOverrideType: string = null;
        salesTaxOverride: number = null;

        emailWorkOrder: boolean = true;
        email: string = '';
        emailNote: string = '';

        previewRecommendation: boolean = false;
        previewRecommendationHtml?: string = null;

        presetNames: PackagePresetName[] = [];
        presetNotes: PackagePresetNote[] = [];

        financePlanOptions: boolean = false;
        financeCompanies: FinanceCompany[] = [];
        financePlan: FinancePlan = null;
        financeBestPrice: number|null = null;
        financePlanExists: boolean = false;

        servicePlanOptions: boolean = false;
        servicePlans: ServicePlan[] = [];
        servicePlan: ServicePlan = null;
        activeServicePlan: ServicePlan = null;
        inactiveServicePlan: ServicePlan = null;
        isUpdatingServicePlan: boolean = false;
        isUpdatingProductDisplay: boolean = false;
        isUpdatingSinglePrice: boolean = false;

        lastServicePlan: ServicePlanAgreement = null;

        termsConditions: TermsConditions[] = [];
        activeTerms: TermsConditions[] = [];
        signatureSlideOut: boolean = false;
        acceptedAllTurns: boolean = false;

        signature: string = null;
        approval: Approval = null;
        signaturePrintName: string = null;
        isSavingSignature: boolean = false;

        originalPackages: Package[] = [];

        showNewItemForm: boolean = false;
        selectedItemType: ServiceableItemType = null;
        serviceItemTypes: ServiceableItemType[] = [];
        serviceItems: ServiceableItem[] = [];

        showCreateTemplate: boolean = false;
        templateFavorite: boolean = false;
        template: Template = new Template();

        blockingSaves: Promise<void>[] = new Array();

        user: App.User.User;

        interval: number;

        approvalTextPhone: string;
        approvalTextPending: boolean = false;
        approvalTextShow: boolean = false;
        approvalTextNew: boolean = false;

        approvalEmail: string = '';
        approvalEmailPending: boolean = false;
        approvalEmailShow: boolean = false;
        approvalEmailNew: boolean = false;

        org: App.Utils.OrganizationETCSettingData;

        sortableOptions:Object = {
            containment: '.packages',
            scrollableContainer: '.work-order-body',
            allowDuplicates: false,
            orderChanged: this.orderChanged.bind(this),
            dragMove: this.dragMove.bind(this)
        };

        departments: Department[];
        departmentsLoaded: boolean = false;

		ssp_price_card_text: string = '□□□□ □□□□□□□□□ □□□□□□□□□□□';

        private newServiceId: number = 0;
        private productEditMap: {[packageId: number]: {[productId: number]: boolean}} = {};

        static $inject: string[] = [
            '$window',
            '$scope',
            '$sce',
            '$state',
            'SelectedAppointment',
            'TitleBarService',
            'ProductService',
            'WorkOrderTemplateService',
            'WorkOrderService',
            'PackageActionsService',
            'HistoryService',
            'OfficeService',
            'UserSession',
            'PermissionService',
            'ToastService',
            '$q',
            'BannerService',
            'ItemManagementService',
            'CustomerService',
            'OrganizationService'
        ];

        constructor(
            private $window: ng.IWindowService,
            private $scope: ng.IScope,
            private $sce: ng.ISCEService,
            private $state: ng.ui.IStateService,
            private SelectedAppointment: SelectedAppointment,
            private TitleBarService: TitleBarService,
            private ProductService: ProductService,
            private WorkOrderTemplateService: WorkOrderTemplateService,
            private WorkOrderService: WorkOrderService,
            private PackageActionsService: PackageActionsService,
            private HistoryService: App.History.HistoryService,
            private OfficeService: OfficeService,
            private UserSession: App.User.UserSession,
            private PermissionService: App.Helpers.PermissionService,
            public ToastService: ToastService,
            public $q: ng.IQService,
            public BannerService: BannerService,
            public ItemManagementService: ItemManagementService,
            public CustomerService: CustomerService,
            protected OrganizationService: App.Utils.OrganizationService
        ) {
            const vm = this;

            TitleBarService.set('Appointment');

            OfficeService.getAppointment().then(response => {
                this.fromOffice = true;
                this.setAppointment(response.data);
            }).catch(() => {
                SelectedAppointment.getAppointment().then((appointment) => {
                    this.setAppointment(appointment);
                    this.getEtcTime();
                });
            });

            this.UserSession.getUser().then((user) => this.user = user);
            this.canEditProducts = this.PermissionService.hasPermission('web.field.work-order.products.edit');

            OrganizationService.getETCSettingDetails().then((org) => {
                vm.org = org.data;
            });

			OrganizationService.getPriceCardText()
				.then((r) => this.ssp_price_card_text = r.data.ssp_price_card_text);

            vm.getPackagePresets();
        }

        setProductOriginals(product: EditedReturnedProduct) {
            if (!product.original_set) {
                product.original_set = true;
                product.original_name = product.service.name;
                product.original_description = product.service.description;
                product.original_price = product.service.service_price_override && product.service.service_price_override.amount || null;
                product.new_price = product.original_price;
            }
        }

        editProduct(product: EditedReturnedProduct, pkg: Package) {
            this.setProductOriginals(product);

            product.last_quantity = product.new_quantity;
            product.last_name = product.service.name;
            product.last_description = product.service.description;
            product.last_price = product.new_price;

            this.productEditMap[pkg.id] = this.productEditMap[pkg.id] || {};
            this.productEditMap[pkg.id][product.id] = true;
        }

        stopEditProduct(product: EditedReturnedProduct, pkg: Package, force?: boolean) {
            if (!force) {
                // Validation
                if (product.is_new) {
                    if (!product.service.department) {
                        return;
                    }
                }
                if (product.is_date) {
                    if (!product.start_date || !product.start_time || !product.end_date || !product.end_time) {
                        return;
                    }
                }
                if (!product.service.name) {
                    return;
                }
            }
            product.is_done = true;
            if (product.is_date) {
                const
                    start = moment(
                        moment(product.start_date).format('YYYY-MM-DD')
                        + ' '
                        + moment(<any>product.start_time, 'HH:mm').format('HH:mm'),
                        'YYYY-MM-DD HH:mm'
                    ),
                    end = moment(
                        moment(product.end_date).format('YYYY-MM-DD')
                        + ' '
                        + moment(<any>product.end_time, 'HH:mm').format('HH:mm'),
                        'YYYY-MM-DD HH:mm'
                    ),
                    diff = Math.abs(end.diff(start, 'hours', true)),
                    hours = Math.floor(diff),
                    seconds = Math.round((diff - hours) * 60),
                    elem = angular.element('<div>' + product.service.description + '</div>'),
                    children = elem.children(),
                    regex = new RegExp(
                        (this.user.technician && this.user.technician.full_name || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                        + 'From: \d{4}-\d{2}-\d{2} \d\d?:\d{2} (a|p)mTo:\d{4}-\d{2}-\d{2} \d\d?:\d{2} (a|p)m'
                    ),
                    html = '<pre>'
                            + (this.user.technician && this.user.technician.full_name || '')
                            + '<br/>From: '
                            + (
                                start.isBefore(end)
                                    ? start.format('YYYY-MM-DD h:mm a') + '<br/>To: ' + end.format('YYYY-MM-DD h:mm a')
                                    : end.format('YYYY-MM-DD h:mm a')   + '<br/>To: ' + start.format('YYYY-MM-DD h:mm a')
                            )
                        + '</pre>';

                let updated = false;

                for (let i = 0; i < children.length; ++i) {
                    if ('PRE' === children[i].tagName && regex.test(children[i].textContent)) {
                        children[i].outerHTML = html;
                        updated = true;
                    }
                }

                product.service.labor_minutes = diff * 60;
                product.service.name = 'Labor ' + hours + ':' + (seconds < 10 ? ('0' + String(seconds)) : seconds);
                product.service.description = elem.html();

                if (!updated) {
                    product.service.description = html
                        + (
                            product.service.description
                                ? '<br/><br/>' + product.service.description
                                : ''
                        );
                }
            }
            this.productEditMap[pkg.id] = this.productEditMap[pkg.id] || {};
            this.productEditMap[pkg.id][product.id] = false;
            if (product.is_new) {
                this.setProductOriginals(product);
            }
        }

        revertProduct(product: EditedReturnedProduct, pkg: Package) {
            if (product.is_new && !product.is_done) {
                pkg.services.splice(pkg.services.findIndex((s: EditedReturnedProduct) => s.id === product.id), 1);
            } else {
                product.new_quantity = product.last_quantity;
                product.new_price = product.last_price;
                product.service.name = product.last_name;
                product.service.description = product.last_description;
            }
            this.stopEditProduct(product, pkg, true);
        }

        showProductEdit(product: EditedReturnedProduct, pkg: Package): boolean {
            return this.productEditMap[pkg.id] && this.productEditMap[pkg.id][product.id];
        }

        addNewService(pkg: Package, dateBased?: boolean) {
            // Only allow one new service at a time
            if (pkg.services.some((s: EditedReturnedProduct) => s.is_new && !s.is_done)) {
                return;
            }
            if (!this.departmentsLoaded) {
                this.ProductService.getDepartments()
                    .then(resp => {
                        this.departments = resp.data;
                        this.departmentsLoaded = true;
                    })
                    .catch(err => this.ToastService.showError('Failed to load departments: ', err));
            }

            const nService: EditedReturnedProduct = <any>{
                id: --this.newServiceId,
                is_new: true,
                is_done: false,
                is_date: dateBased === true,

                quantity: 1,
                index: (pkg.services.sort((a, b) => b.index - a.index)[0] || { index: -1 }).index + 1,
                service: {
                    name: '',
                    description: '',
                },
            };

            if (nService.is_date) {
                const date = moment(moment().format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm');

                nService.start_date = date.toDate();
                nService.start_time = date.toDate();
                nService.end_date = date.toDate();
                nService.end_time = date.toDate();

                nService.service.name = 'Labor';
            }

            pkg.services.push(nService);
            this.editProduct(nService, pkg);
        }

        getPackageList(): Package[] {
            if (this.inArchivedMode) {
                return this.isArchivedLoading ? [] : this.archivedPackages;
            }

            this.sortPackages();

            return this.appointment.service_request.packages;
        }

        toggleArchivedMode(): void {
            this.$state.go('.', { deleted: this.inArchivedMode ? '0' : '1' });

            if (this.inArchivedMode) {
                this.inArchivedMode = false;
                if (this.isArchivedLoading) {
                    return;
                }

                let shownPackageError = false;

                this.archivedPackages
                    .filter((pkg) => pkg.index !== this.originalArchivedIndecies[pkg.id])
                    .forEach((pkg) => {
                        this.ProductService.updatePackage(this.appointment.service_request.id, pkg, { quiet: 1 })
                            .catch((err) => {
                                if (!shownPackageError) {
                                    shownPackageError = true;
                                    this.ToastService.showError('Failed to update package order: ', err);
                                }
                            });
                        this.originalArchivedIndecies[pkg.id] = pkg.index;
                    });

                return;
            }

            this.inArchivedMode = true;
            this.isShowingEmail = false;
            this.PackageActionsService.resetSelections();

            if (this.isArchivedLoading) {
                return;
            }

            this.isArchivedLoading = true;

            this.ProductService.getPackages(this.appointment.service_request.id, { archived: 1 })
                .then((response) => {
                    this.archivedPackages = response.data || [];
                    this.pendingArchivedPackages
                        .filter((pkg) => this.archivedPackages.findIndex((p) => p.id === pkg.id) === -1)
                        .forEach((pkg) => this.archivedPackages.push(pkg));
                    this.pendingArchivedPackages = [];
                    this.archivedPackages = this.archivedPackages.map(pkg => this.sortProducts(pkg));
                    this.archivedPackages.forEach((pkg) => this.originalArchivedIndecies[pkg.id] = pkg.index);
                    this.fixArchivedPackageIndecies();
                    this.isArchivedLoading = false;
                });
        }

        fixArchivedPackageIndecies() {
            this.archivedPackages = this.archivedPackages.sort((pkg1, pkg2) => pkg1.index - pkg2.index);
            for (let i = this.archivedPackages.length - 1; i >= 0; --i) {
                this.archivedPackages[i].index = i;
            }
        }

        addArchivedPackage(pkg: Package) {
            if (this.archivedPackages === null) {
                this.pendingArchivedPackages.push(pkg);
            } else {
                this.archivedPackages.push(pkg);
                this.originalArchivedIndecies[pkg.id] = pkg.index;
                this.fixArchivedPackageIndecies();
            }
        }

        showMode(pkg: Package, mode: string): boolean {
            return pkg.mode === mode || this.getModeBool(mode);
        }

        getActiveTerms(): TermsConditions[]
        {
            return this.termsConditions.filter((termsConditions: TermsConditions) => {
                return termsConditions.approved;
            });
        }

        checkTerms(): boolean {
            return (this.termsConditions.length === 0) || (this.getActiveTerms().length >= 1);
        }

        isPositive(number: string|number): boolean {
            if (angular.isString(number)) {
                number = parseFloat(number.replace(/,/g, ''));
            }
            return number > 0;
        }

        formatDate(dateString: string): string {
            let date = new Date(dateString),
                dateParts = date.toDateString().split(' ');

            return dateParts[1] + ' ' + dateParts[2] + ', ' + dateParts[3];
        }

        frequencyToTerm(frequency: string): string {
            switch(frequency) {
                case 'monthly':
                case 'month':
                    return 'month';
                case 'yearly':
                case 'year':
                case 'annual':
                    return 'year';
                default:
                    throw 'Unable to get term from ' + frequency;
            }
        }

        removeFinance(): void {
            if (this.financePlan !== null) {
                this.financePlan = null;
                this.updateFinancePlan(this.financePlan);
            }
        }

        updateFinancePlan(financePlan: FinancePlan) {
            const vm = this;

            if (financePlan === null) {
                vm.financePlan = null;
            }

            return vm.WorkOrderService.updateFinancePlan(vm.appointment.service_request.id, financePlan).then((response) => {
                vm.appointment.service_request.finance_plan = vm.financePlan = response.data.finance_plan;
                vm.getPackages().then(() => {
                    vm.getSummary().then(() => {
                        componentHandler.upgradeAllRegistered();
                    });
                });
            });
        }

        usesFinancePlans(): boolean {
            return this.financePlanExists && this.getModeBool('finance') || !!this.financePlan;
        }

        getModeBool(type: string): boolean {
            return <boolean>(
                this.appointment &&
                this.appointment.service_request &&
                this.appointment.service_request.customer &&
                this.appointment.service_request.customer.rate_mode &&
                this.appointment.service_request.customer.rate_mode[type]
            );
        }

        openFinancePlans(): void {
            this.financePlanLoading = true;
            this.financePlanOptions = true;
            componentHandler.upgradeAllRegistered();

            this.getFinancePlans()
                .then(() => {
                    if (!this.usesFinancePlans()) {
                        this.financePlanOptions = false;
                    }

                    this.financePlanLoading = false;
                    componentHandler.upgradeAllRegistered();
                });
        }

        getFinancePlans(): ng.IPromise<void> {
            return this.WorkOrderService.getFinanceCompanies(this.appointment.service_request.id)
                .then((response) => {
                    this.financeCompanies = [];
                    (response.data || []).forEach((company: FinanceCompany) => {
                        let plans: FinancePlan[] = [];

                        (company.plans || []).forEach((plan: FinancePlan) => {
                            if (!plan.visible) {
                                return;
                            }
                            this.financePlanExists = true;
                            let amount = parseFloat(plan.amount.replace(/,/g, ''));
                            if (this.financeBestPrice === null || amount < this.financeBestPrice) {
                                this.financeBestPrice = amount;
                            }
                            plans.push(plan);
                        });
                        if (plans.length) {
                            company.plans = plans;
                            this.financeCompanies.push(company);
                        }
                    });
                    componentHandler.upgradeAllRegistered();
                });
        }

        removeWarranty(pkg: Package): void {
            if (!angular.isNumber(pkg.warranty.id)) {
                pkg.warranty = null;
            }
        }

        savePackages(): ng.IPromise<Package[]> {
            const promises: {[id: number]: ng.IPromise<Package>} = {};

            // TODO: Only send changed packages
            this.appointment.service_request.packages.forEach((toUpdatePkg) => {
                promises[toUpdatePkg.id] = this.savePackage(toUpdatePkg).then((updatedPkg) => {
                    this.selectPreset(updatedPkg);
                    return updatedPkg;
                });
            });

            return this.$q.all(promises).then((response) => {
                const updatedPackageIds = Object.keys(response),
                    updatedPackages: Package[] = []

                updatedPackageIds.forEach((id) => {
                    const pkg: Package = response[id];

                    updatedPackages.push(pkg);

                    for (let i = this.appointment.service_request.packages.length - 1; i >= 0; --i) {
                        if (this.appointment.service_request.packages[i].id === pkg.id) {
                            this.appointment.service_request.packages[i] = this.sortProducts(pkg);
                            break;
                        }
                    }

                    for (let i = this.originalPackages.length - 1; i >= 0; --i) {
                        if (this.originalPackages[i].id === pkg.id) {
                            this.originalPackages[i] = angular.copy(pkg);
                            break;
                        }
                    }

                });

                const promise = updatedPackages.length
                    ? this.getSummary().then(() => {
                        return updatedPackages;
                    })
                    : this.$q.when(updatedPackages);

                return promise.then(d => {
                    this.appointment.service_request.packages.forEach((p) => p.services.forEach(s => this.setProductOriginals(<EditedReturnedProduct><any>s)));
                    return d;
                });
            });
        }

        getQuantity(product: Product): void {
            product.new_quantity = parseFloat(String(product.new_quantity)) || 1;
            product.new_quantity = product.new_quantity <= 0 ? 1 : product.new_quantity;
        }

        savePackage(pkg: Package): ng.IPromise<Package> {
            const promises: ng.IHttpPromise<{}>[] = [],
                services: EditedReturnedProduct[] = <EditedReturnedProduct[]>pkg.services;

            services.forEach(service => {
                const isChanged = service.is_new || (angular.isDefined(service.new_quantity) && service.new_quantity !== service.quantity
                        || service.original_set && (
                            service.original_name !== service.service.name
                            || service.original_description !== service.service.description
                            || service.original_price !== service.new_price
                        ));

                if (isChanged) {
                    service.quantity = service.new_quantity;

                    service.original_set = true;
                    service.original_name = service.service.name;
                    service.original_description = service.service.description;
                    service.original_price = service.new_price;
                    service.service.service_price_override = service.original_price
                        ? <any>{ amount: service.original_price }
                        : null;

                    if (service.is_new) {
                        const newService: EditedReturnedProduct = <any>{
                            quantity: service.quantity,
                            index: service.index,
                            create_service: {
                                name: service.original_name,
                                description: service.original_description,
                                service_price_override: service.original_price,
                                department: service.service.department,
                                labor_minutes: service.service.labor_minutes || 0,
                                material_cost: service.service.material_cost || 0,
                                tax_exempt: service.service.tax_exempt,
                            }
                        };

                        if (!this.PermissionService.hasPermission('web.field.work-order.products.edit_price')) {
                            delete newService.create_service.service_price_override;
                        }
                        service.is_new = false;

                        promises.push(
                            this.ProductService.createPackageService(
                                this.appointment.service_request.id,
                                pkg.id,
                                newService
                            )
                        );
                    } else {
                        const newService: EditedReturnedProduct = <any>{
                            id: service.id,
                            quantity: service.quantity,
                            name: service.original_name,
                            description: service.original_description,
                            service_price_override: service.original_price,
                            index: service.index,
                        };

                        if (!this.PermissionService.hasPermission('web.field.work-order.products.edit_price')) {
                            delete (<Product><any>newService).service_price_override;
                        }

                        promises.push(
                            this.ProductService.updatePackageService(
                                this.appointment.service_request.id,
                                pkg.id,
                                newService
                            )
                        );
                    }
                }
            });

            return this.$q.all(promises).then(() => {
                let savePkg = angular.copy(pkg);
                delete savePkg.services; // We do not want to send them on update as it will duplicate

                return this.ProductService.updatePackage(this.appointment.service_request.id, savePkg)
                    .then((newPackage) => {
                        return pkg = newPackage.data;
                    });
            });
        }

        setAppointment(appointment: Appointment): ng.IPromise<void> {
            const vm = this,
                isDifferent = !vm.appointment || vm.appointment.service_request.id !== appointment.service_request.id;

            vm.appointment = appointment;
            vm.appointment.service_request.packages = [];
            vm.servicePlan = vm.appointment.service_request.service_plan;
            vm.financePlan = vm.appointment.service_request.finance_plan;

            if (isDifferent) {
                vm.inArchivedMode = false;
                vm.archivedPackages = null;
                vm.pendingArchivedPackages = [];
                vm.originalArchivedIndecies = {};
                vm.isArchivedLoading = false;
                vm.pendingRestores = {};
            }

            vm.setCustomerTitle();
            vm.PackageActionsService.subscribeCallback(vm.updateAll.bind(this));
            vm.PackageActionsService.setActiveAppointmentId(vm.appointment.id);

            let plan = vm.appointment.service_request.customer.last_service_plan;

            if(plan) {
                if(plan.active) {
                    vm.activeServicePlan = plan.service_plan;
                    if(vm.activeServicePlan) {
                        vm.activeServicePlan.id = 'a' + vm.activeServicePlan.id;
                    }
                }
                if(!plan.active) {
                    vm.inactiveServicePlan = plan.service_plan;
                }
            }

            vm.lastServicePlan = plan;

            if (!vm.servicePlan && vm.activeServicePlan) {
                vm.servicePlan = angular.copy(vm.activeServicePlan);
            }

            let emails = vm.appointment.service_request.customer.emails;

            this.email = emails.length
                ? emails[0].email
                : '';

            let phones = vm.appointment.service_request.customer.phone_numbers;
            this.approvalTextPhone = phones.length
                ? (phones.filter(p => p.send_text)[0] || {number: ''}).number
                : '';

            if (this.$state.params.deleted === '1') {
                this.toggleEditMode();
                this.toggleArchivedMode();
            }

            return this.updateAll();
        }

        toggleMobileApproval() {
            this.approvalEmailShow = false;
            this.approvalTextShow = !this.approvalTextShow;
        }

        sendApprovalText() {
            if (this.approvalTextPending) {
                return;
            }

            this.approvalTextPending = true;

            this.WorkOrderService
                .sendApprovalText(
                    this.appointment.service_request.id,
                    this.approvalTextPhone,
                    this.fromOffice ? null : this.appointment.id
                )
                .then(() => {
                    this.ToastService.show('Sent approval text');
                    if (!this.appointment.service_request.customer.phone_numbers.find(p => p.number === this.approvalTextPhone)) {
                        this.appointment.service_request.customer.phone_numbers.push({
                            id: null,
                            number: this.approvalTextPhone,
                            send_text: true,
                        });
                    }
                })
                .catch(err => this.ToastService.showError('Failed to send approval: ', err))
                .finally(() => {
                    this.approvalTextPending = false;
                    this.toggleMobileApproval();
                });
        }

        toggleEmailApproval() {
            this.approvalTextShow = false;
            this.approvalEmailShow = !this.approvalEmailShow;
        }

        toggleApprovalEmailNew() {
            this.approvalEmailNew = !this.approvalEmailNew;
            this.approvalEmail = '';
        }

        sendApprovalEmail() {
            if (this.approvalEmailPending) {
                return;
            }

            this.approvalEmailPending = true;

            this.WorkOrderService
                .sendApprovalEmail(
                    this.appointment.service_request.id,
                    this.approvalEmail,
                    this.fromOffice ? null : this.appointment.id
                )
                .then(() => {
                    this.ToastService.show('Sent approval email');
                    if (!this.appointment.service_request.customer.emails.find(e => e.email === this.approvalEmail)) {
                        this.appointment.service_request.customer.emails.push({
                            id: null,
                            email: this.approvalEmail,
                            marketing: true,
                        });
                    }
                })
                .catch(err => this.ToastService.showError('Failed to send approval: ', err))
                .finally(() => {
                    this.approvalEmailPending = false;
                    this.toggleEmailApproval();
                });
        }

        updateAll() {
            const vm = this;

            return vm.getPackages().then(() => {
                vm.getSummary().then(() => {
                    vm.getServicePlans();
                    vm.getServiceItems();
                    vm.getFinancePlans();
                    vm.getTermsConditions();
                    vm.getServiceItemTypes();
                    vm.getSignature();
                });
            });
        }

        selectPreset(pkg: Package): void {
            const vm = this;

            pkg.presetName = (vm.presetNames || []).reduce((r: string | null, name: PackagePresetName) => {
                return r || (name.description === pkg.name && name.description) || null;
            }, null);

            pkg.presetNote = pkg.description && (vm.presetNotes || []).reduce((r: string | null, note: PackagePresetNote) => {
                return r || (note.name === pkg.description && note.name) || null;
            }, null) || null;
        }

        getPackages() {
            const vm = this;

            return vm.ProductService.getPackages(vm.appointment.service_request.id).then((response) => {
                response.data.forEach(vm.selectPreset.bind(vm));

                vm.appointment.service_request.packages = response.data.map(pkg => {
                    pkg.services.forEach(s => this.setProductOriginals(<EditedReturnedProduct><any>s));
                    return vm.sortProducts(pkg);
                });
                vm.originalPackages = angular.copy(response.data);
            });
        }

        getPackagePresets() {
            const vm = this;

            return vm.ProductService.getPackagePresetNames().then((response) => {
                vm.presetNames = response.data;

                vm.ProductService.getPackagePresetNotes().then((response) => {
                    vm.presetNotes = response.data;

                    vm.ProductService.getWarranties().then((response) => {
                        vm.warranties = response.data;
                    });
                });
            });
        }

        getSummary() {
            const vm = this;

            return vm.$q.all(vm.blockingSaves).then(() => {
                return vm.WorkOrderService.getSummary(vm.appointment.service_request.id).then((response) => {
                    vm.summary = response.data;
                    vm.blockingSaves = [];
                    vm.sortPackages();
                });
            });
        }

        getTermsConditions() {
            const vm = this;

            return vm.ProductService.getTermsConditions().then((response) => {
                vm.termsConditions = response.data;
                if (vm.approval){
                    vm.termsConditions.forEach((terms) => {
                        terms.approved = true;
                    })
                }
            });
        }

        setCustomerTitle() {
            const vm = this,
                customer = vm.appointment.service_request.customer;

            if(customer) {
                vm.title = customer.company_name ? customer.company_name : customer.full_name;
            }
        }

        toggleSinglePriceWorkOrder() {
            if (this.isUpdatingSinglePrice) {
                return;
            }

            this.isUpdatingSinglePrice = true;

            this.ProductService.updateServiceRequest(this.appointment.service_request.id, {
                force_hide_regular: this.appointment.service_request.can_show_regular_pricing
            }).then((response) => {
                this.appointment.service_request.can_show_regular_pricing = response.data.can_show_regular_pricing;
                this.appointment.service_request.packages.forEach((pkg, index) => {
                    pkg.can_show_regular_pricing = (<Package[]>response.data.packages)
                        .find((pk) => pk.id === pkg.id)
                        .can_show_regular_pricing;
                });
            }).finally(() => {
                this.isUpdatingSinglePrice = false;
            });
        }

        doPackageAction(pkg: Package, action: string) {
            const vm = this;

            if (this.inArchivedMode) {
                if (action === 'restore') {
                    if (this.pendingRestores[pkg.id]) {
                        return;
                    }

                    this.pendingRestores[pkg.id] = true;
                    let index = this.appointment.service_request.packages.length;
                    this.appointment.service_request.packages.push(pkg);

                    this.ProductService.restorePackage(
                        this.appointment.service_request.id, {
                            id: pkg.id,
                            index: index,
                        }, {
                            quiet: 1
                        }
                    ).then((response) => {
                        pkg.index = index;
                        if (this.archivedPackages !== null) {
                            let idx = this.archivedPackages.findIndex((p) => p.id === pkg.id);
                            if (idx !== -1) {
                                this.archivedPackages.splice(idx, 1);
                            }
                        }
                    }).catch((err) => {
                        this.ToastService.showError('Failed to restore package: ', err);
                        this.appointment.service_request.packages.splice(index, 1);
                    }).finally(() => this.pendingRestores[pkg.id] = false);
                }

                return;
            }

            switch(action) {
                case 'add':
                    vm.$state.go('zipSolutions.price-guide', {
                        packageId: pkg.id
                    });

                    break;
                case 'remove':
                    vm.showDeletePackageWarning(pkg);

                    break;
                case 'single':
                    this.ProductService.updatePackage(this.appointment.service_request.id, {
                        id: pkg.id,
                        force_hide_regular: pkg.can_show_regular_pricing
                    }).then((response) => {
                        Object.keys(response.data).forEach((key) => {
                            pkg[key] = response.data[key];
                        });
                        pkg.packageAction = '';
                    });
                    break;
                case 'duplicate':
                    this.ProductService.duplicatePackage(vm.appointment.service_request.id, pkg.id).then((response) => {
                        vm.appointment.service_request.packages.push(response.data);
                        vm.sortPackages();
                        pkg.packageAction = '';
                    });
                    break;
                default:
                    break;
            }
        }

        showDeletePackageWarning(pkg: Package) {
            const message = 'Are you sure you want to delete this package?',
                result = window.confirm(message),
                vm = this;

            if (result) {
                vm.deletePackage(pkg);
            }
        }

        deletePackage(pkg: Package) {
            const vm = this;

            return this.savePackage(pkg)
                .then(() => vm.ProductService.deletePackage(vm.appointment.service_request.id, pkg.id))
                .then(() => {
                    const index = vm.appointment.service_request.packages.findIndex((pk) => pk.id === pkg.id);

                    vm.appointment.service_request.packages.splice(index, 1);
                    vm.sortPackages();
                    vm.addArchivedPackage(pkg);

                    return pkg;
                });
        }

        getCurrentPricing(pkg: Package): string {
            return this.servicePlan
                ? this.getMaintenancePricing(pkg)
                : this.getRegularPricing(pkg);
        }

        getRegularPricing(pkg: Package): string {
            let price = '$';

            switch(pkg.mode) {
                case 'admin':
                    price = 'Admin';
                    break;
                case 'regular':
                case 'whilehere':
                    price += pkg.prices[pkg.mode].regular;
                    break;
                case 'itemized':
                    price += pkg.prices[pkg.mode].whilehere;
                    break;
                default:
                    price += pkg.prices.regular.regular;
                    break;
            }

            return price;
        }

        getMaintenancePricing(pkg: Package): string {
            let price = '$';

            switch(pkg.mode) {
                case 'admin':
                    price = 'Admin';
                    break;
                case 'regular':
                case 'whilehere':
                    price += pkg.prices[pkg.mode].service;
                    break;
                case 'itemized':
                    if (this.usesServicePlans() || !this.showMultiPrice(pkg)) {
                        price += pkg.prices.itemized.service;
                    } else {
                        price += pkg.prices.itemized.whilehere;
                    }
                    break;
                default:
                    price += pkg.prices.regular.service;
                    break;
            }

            return price;
        }

        getMaintenanceMonthlyPrice(pkg: Package): string {
            switch(pkg.mode) {
                case 'admin':
                    return null;
                case 'regular':
                case 'whilehere':
                case 'itemized':
                    return pkg.prices[pkg.mode].servicemonthly;
                default:
                    return pkg.prices.regular.servicemonthly;
            }
        }

        canBeFinanced(pkg: Package): boolean {
            return this.getMaintenanceMonthlyPrice(pkg) != null && this.appointment.service_request.customer.can_show_financing;
        }

        getMaintenanceMonthlyPricing(pkg: Package): string {
            let price = this.getMaintenanceMonthlyPrice(pkg);

            if(price == null){
                return null;
            }

            return `${price} / month *`;
        }

        getItemizedPrice(packageProduct: ReturnedProduct, pkg: Package): string {
            let price = '$';

            if (this.servicePlan || this.activeServicePlan || !pkg.can_show_regular_pricing) {
                price += angular.isDefined(packageProduct.service.while_here_with_agreement)
                    ? packageProduct.service.while_here_with_agreement
                    : '';
            } else {
                price += angular.isDefined(packageProduct.service.while_here_with_out_agreement)
                    ? packageProduct.service.while_here_with_out_agreement
                    : '';
            }

            return price === '$'
                ? ''
                : price;
        }

        isAdmin(pkg: Package): boolean {
            return pkg.mode === 'admin';
        }

        isWhileHere(pkg: Package): boolean {
            return pkg.mode === 'whilehere';
        }

        isItemized(pkg: Package): boolean {
            return pkg.mode === 'itemized';
        }

        toggleEditMode(): void {
            if (this.inArchivedMode) {
                this.toggleArchivedMode();
            }
            if (this.inEditMode) {
                this.BannerService.triggerResizeEvent(); // This is for the fit text plugin
                this.savePackages();
            }

            this.inEditMode = !this.inEditMode;
            this.isShowingEmail = false;
            this.productEditMap = {};
            this.PackageActionsService.resetSelections();
        }

        saveRecommendations(): void {
            if (!this.isShowingEmail || !this.PackageActionsService.selectedPackages.length || this.isSaving) {
                return;
            }

            this.HistoryService.emailRecommendations(
                this.appointment.service_request.id,
                this.PackageActionsService.selectedPackages.map(p => p.id),
                '',
                this.emailNote,
                true
            ).then(() => {
                this.PackageActionsService.makeAction('recommend', this.appointment.service_request);
                this.isShowingEmail = false;
                this.emailNote = '';
            });
        }

        sendEmail(): void {
            if (!this.isShowingEmail || this.isSaving) {
                return;
            }

            this.isSaving = true;
            let promise: ng.IHttpPromise<any> = null,
                ids = this.PackageActionsService.selectedPackages.map(p => p.id);

            this.savePackages().finally(() => {
                if (this.isShowingRecommendation() && this.PackageActionsService.selectedPackages.length) {
                    promise = this.HistoryService.emailRecommendations(
                        this.appointment.service_request.id,
                        ids,
                        this.email,
                        this.emailNote,
                        true
                    );
                } else {
                    promise = this.WorkOrderService.email(
                        this.appointment.service_request.id,
                        this.email
                    );
                }

                promise.then(() => {
                    this.isShowingEmail = false;
                    this.emailNote = '';

                    if (this.isShowingRecommendation()) {
                        this.PackageActionsService.makeAction('recommend', this.appointment.service_request);
                    } else {
                        this.PackageActionsService.resetSelections();
                        this.PackageActionsService.packageCheckboxesVisible = false;
                    }

                }).finally(() => this.isSaving = false);
            });
        }

        editEmail() {
            this.editEmailFlyout = false;

            if (this.showNewEmail) {
                this.CustomerService.createEmail(this.appointment.service_request.customer.id, this.newEmail).then((email) => {
                    this.appointment.service_request.customer.emails.push(email.data);
                    this.email= email.data.email;
                    this.newEmail = '';
                    this.showNewEmail = false;
                    this.ToastService.show('Email created');
                });
            }
        }

        toggleEmailSelection(): void {
            this.isShowingEmail = !this.isShowingEmail;
            this.PackageActionsService.resetSelections();
        }

        removeServiceFromPackage(service: Product, pkg: Package) {
            const vm = this;

            return vm.ProductService.deletePackageService(vm.appointment.service_request.id, pkg.id, service.id).then(() => {
                pkg.services.splice(pkg.services.findIndex(p => p.id === service.id), 1);
                return vm.ProductService.getPackage(vm.appointment.service_request.id, pkg.id).then((response) => {
                    pkg.prices = response.data.prices;
                    pkg.code = response.data.code;

                    return vm.getSummary();
                })
            });
        }

        showPackageNote(pkg: Package): boolean {
            return pkg.description !== null;
        }

        showBannerFlyout(pkg: Package) {
            const vm = this;

            vm.bannerPackage = pkg;
            this.bannerOptions = true;
        }

        showSalesTaxFlyout(taxType: string) {
            const vm = this;

            vm.salesTaxOverrideType = taxType;
            vm.editSalesTax = true;
        }

        overrideSalesTax() {
            const vm = this;
            vm.WorkOrderService.overrideSalesTax(vm.appointment.service_request.id, vm.salesTaxOverride, vm.salesTaxOverrideType).then(() => {
                vm.getSummary();
                vm.editSalesTax = false;
                vm.salesTaxOverride = null;
            });
        }

        showEtcButton() {
            const today = moment().format('YYYY-MM-DD');

            if (this.appointment && this.appointment.scheduled_date === today) {
                return true;
            }
        }

        showEtcFlyout() {
            const vm = this;
            vm.editEtc = true;
        }

        updateEtc() {
            const vm = this,
                today = moment().format('YYYY-MM-DD');

            if (!vm.estimatedTime) {
                return;
            }

            if (vm.appointment && vm.appointment.scheduled_date !== today) {
                vm.editEtc = false;
                vm.ToastService.showError('Failed to save ETC: Appointment must be today');
                return;
            }

            let duration = null;

            if (vm.org.appointment_duration_matches_estimated_time) {
                let minutes = moment.duration(vm.estimatedTime).asMinutes(),
                    now = moment(),
                    startTime = moment(vm.appointment.scheduled_date + ' ' + vm.appointment.scheduled_time, 'YYYY-MM-DD HH:mm');

                if (startTime.isBefore(now)) {
                    const timeInto = moment.duration(startTime.diff(now));

                    duration = minutes - timeInto.asMinutes();
                } else {
                    duration = minutes;
                }

                duration = Math.max(15, duration);
            }

            return vm.SelectedAppointment.updateAppointmentEtc(vm.estimatedTime, duration, false).then(() => {
                vm.editEtc = false;
                vm.getEtcTime();
                vm.ToastService.show('Estimated Time Saved');
            }).catch(err => {
                this.ToastService.showError('Failed to save ETC: ', err);
            });
        }

        getEtcTime() {
            const vm = this;

            if (vm.appointment && vm.appointment.estimated_completion_time) {
                vm.estimatedEndTime = moment(vm.appointment.scheduled_time, 'HH:mm')
                    .add(vm.appointment.scheduled_duration, 'm')
                    .format('h:mm A');
            }
        }

        showAdjustmentFlyout() {
            this.estimatedTime = this.appointment.estimated_completion_time;
            this.editAdjustments = true;
        }

        addAdjustment() {
            const vm = this;
            return vm.WorkOrderService.addAdjustment(vm.appointment.service_request.id, vm.adjustmentCode).then(() => {
                vm.getSummary();
                vm.editAdjustments = false;
                if (!vm.summary.coupon) {
                    vm.adjustmentCode = "";
                }
            });
        }

        removeAdjustment() {
            const vm = this;
            return vm.WorkOrderService.addAdjustment(vm.appointment.service_request.id, null).then(() => {
                vm.getSummary();
                vm.adjustmentCode = "";
            })
        }

        secureIframeSrc(videoId: string) {
            const vm = this;
            return vm.$sce.trustAsResourceUrl(`https://www.youtube.com/embed/${videoId}?autoplay=1`);
        }

        getDefaultServicePlan(): ServicePlan|null {
            let defaults = this.servicePlans.filter((servicePlan: ServicePlan) => {
                return servicePlan.default_service_plan;
            });

            return defaults && defaults.length && defaults[0] || null;
        }

        getServicePlans(): ng.IPromise<ServicePlan[]> {
            const vm = this;

            return vm.WorkOrderService.getServicePlans(vm.appointment.service_request.id).then((response) => {
                var found = false;

                vm.servicePlans = response.data || [];
                if (this.activeServicePlan) {
                    // Put current service plan first
                    vm.servicePlans.unshift(this.activeServicePlan);
                }

                return vm.servicePlans;
            });
        }

        checkWarranty(warranty: Warranty, pkg: Package) {
            return warranty.min_invoice_amount <= parseFloat(pkg.prices.whilehere.regularnormally.replace(',', ''));
        }

        servicePlanTermText(servicePlan: ServicePlan) {
            if(angular.isUndefined(servicePlan) || servicePlan === null) {
                return '';
            }
            return servicePlan.term === 'monthly' ? 'Monthly' : 'Annually';
        }

        servicePlanPaymentTerm(servicePlan: ServicePlan) {
            if(angular.isUndefined(servicePlan) || servicePlan === null) {
                return '';
            }
            return servicePlan.term === 'monthly' ? 'mo' : 'yr';
        }

        getServicePlanTerm(servicePlan: ServicePlan) {
            if(angular.isUndefined(servicePlan) || servicePlan === null) {
                return '';
            }
            return servicePlan.term.replace(/(^|\s)(\w)/g, (match: string) => match.toUpperCase());
        }

        updateServicePlan(servicePlan: ServicePlan) {
            const vm = this;

            if (vm.isUpdatingServicePlan) {
                return;
            }

            vm.isUpdatingServicePlan = true;
            vm.servicePlan = servicePlan === null ? null : servicePlan;

            return vm.WorkOrderService.updateServicePlan(
                vm.appointment.service_request.id,
                servicePlan === null || (vm.activeServicePlan && servicePlan.id === vm.activeServicePlan.id)
                    ? null
                    : vm.servicePlan
            ).then((response) => {
                vm.appointment.service_request.service_plan = vm.servicePlan =
                    response.data.service_plan || angular.copy(vm.activeServicePlan);

                vm.getPackages().then(() => {
                    vm.getSummary().then(() => {
                        vm.isUpdatingServicePlan = false;
                    });
                });
            });
        }

        usesServicePlans(): boolean {
            return (this.servicePlans.length > 0 && this.getModeBool('service_plan')) || Boolean(this.servicePlan);
        }

        showDiscount(pkg: Package): boolean {
            return !this.isAdmin(pkg) && this.usesServicePlans() && !!pkg.can_show_regular_pricing && Number(pkg.discount) > 0;
        }

        showMultiPrice(pkg: Package): boolean {
            return this.usesServicePlans() && !!pkg.can_show_regular_pricing && this.getRegularPricing(pkg) !== this.getMaintenancePricing(pkg);
        }

		getSSPCardText(): string {
			return this.ssp_price_card_text;
		}

        isAnyAdmin(): boolean {
            if (!this.appointment.service_request) {
                return;
            }

            return this.appointment.service_request.packages.some(pkg => {
                return pkg.mode === 'admin';
            });
        }

        summaryCostDisplay(value: string, pkg?: Package, negative?: boolean, forceNonAdmin?: boolean) {
            const vm = this;

            if(!vm.appointment || !vm.appointment.service_request || !angular.isString(value)) {
                return '';
            }

            const isAdmin = !forceNonAdmin && (pkg
                    ? this.isAdmin(pkg)
                    : vm.isAnyAdmin()
                );

            negative = negative || value.indexOf('-') === 0;

            return isAdmin
                ? 'Admin Priced'
                : ((negative ? '-' : '') + '$' + value.replace(/^-/, ''));
        }

        getSignature() {
            const vm = this;

            vm.WorkOrderService.fetchSignature(vm.appointment.service_request.id)
                .then(response => {
                    vm.approval = response.data;
                    vm.approval.created = new Date(vm.approval.created).toLocaleString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) + " at " +
                                            new Date(vm.approval.created).toLocaleTimeString("en-US", {hour: 'numeric', minute: 'numeric'});
                    vm.signature = vm.approval.data_url;
                })
                .catch(() => true)
                .finally(() => vm.isApporvalLoaded = true);
        }

        saveSignatureFormFromInput(event: any) {
            if (event.keyCode === 13) {
                event.target.blur();
                this.saveSignatureForm();
            }
        }

        saveSignatureForm(): null | void {
            if (this.isSignatureEmpty() || this.isPrintNameEmpty() || this.isSavingSignature) {
                return null;
            }

            this.isSavingSignature = true;

            if (this.emailWorkOrder && Boolean(this.email)) {
                this.WorkOrderService.email(this.appointment.service_request.id, this.email);
            }

            this.WorkOrderService.saveSignature(
                this.appointment.service_request.id,
                this.signature,
                this.signaturePrintName,
                this.summary.total,
                this.getActiveTerms()
            ).then(response => {
                this.signatureSlideOut = false;
                this.approval = response.data;
                this.approval.created =
                    new Date(this.approval.created).toLocaleString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
                    + " at " +
                    new Date(this.approval.created).toLocaleTimeString("en-US", {hour: 'numeric', minute: 'numeric'});
                this.showEtcFlyout();
            }).catch(err => {
                this.ToastService.showError('Failed to save approval: ', err);
            }).finally(() => {
                this.isSavingSignature = false;
            });
        }

        isPrintNameEmpty() {
            return this.signaturePrintName === null;
        }

        isSignatureEmpty() {
            return !Boolean(this.signature);
        }

        displayDate(date: Date): string {
            return moment(date).format('YYYY-MM-DD');
        }

        isServiceItemChecked(serviceItem: ServiceableItem) {
            return serviceItem.service_request !== null && angular.isDefined(serviceItem.service_request);
        }

        toggleNewItemForm() {
            this.showNewItemForm = !this.showNewItemForm;
        }

        toggleServicePlanOptions() {
            this.servicePlanOptions = this.usesServicePlans() && !this.servicePlanOptions;
            this.showNewItemForm = false;
        }

        getServiceItemTypes() {
            return this.ItemManagementService.GetServiceableItemTypes().then((response) => {
                this.serviceItemTypes = response.data;
            });
        }

        getServiceItems() {
            return this.ItemManagementService.GetServiceableItemListByCustomer(this.appointment.service_request.customer.id, this.appointment.service_request.service_address.id).then((response) =>  {
                this.serviceItems = response.data;
            });
        }

        updateServiceItem(serviceItem: ServiceableItem) {
            const vm = this;
            serviceItem.service_request = vm.isServiceItemChecked(serviceItem)
                ? null
                : { id: vm.appointment.service_request.id };

            return vm.ItemManagementService.UpdateServiceableItem(serviceItem).then((response) =>  {
                serviceItem = response.data;

                return vm.getSummary();
            });
        }

        createServiceItem() {
            const vm = this;

            const serviceableItem : ServiceableItemCreate = {
                address: vm.appointment.service_request.service_address.id,
                customer: vm.appointment.service_request.customer.id,
                in_service: true,
                maintained: false,
                serviceable_item_type: vm.selectedItemType.id,
                created_service_request: vm.appointment.service_request.id,
            };

            return this.ItemManagementService.CreateServiceableItem(serviceableItem).then(() => {
                this.showNewItemForm = false;
                this.getServiceItems();
            });
        }

        cancelCreatingServiceItem() {
            this.showNewItemForm = false;
        }

        trixChange(e: any, editor: any, config: TrixConfig) {
            const doc = editor ? editor.getDocument() : null,
                count = doc ? doc.getLength() : null;

            config.characterCount = count ? count.toString() : '';
        }

        getNewTrixConfig(config: TrixConfig) {
            return new TrixConfig(config);
        }

        toggleCreateTemplate() {
            this.template.reset();
            this.showCreateTemplate = !this.showCreateTemplate;
        }

        toggleEmail() {
            this.isShowingEmail = !this.isShowingEmail;
        }

        shareTypeValue(value: 'global' | 'associated' | 'company'): boolean {
            return (value === 'global' && this.template.public) ||
                (value === 'associated' && this.template.shareWithAssoc) ||
                (!this.template.public && !this.template.shareWithAssoc);
        }

        selectShareType(value: 'global' | 'associated' | 'company') {
            switch(value) {
                case 'global':
                    this.template.public = true;
                    this.template.shareWithAssoc = false;
                    break;
                case 'associated':
                    this.template.public = false;
                    this.template.shareWithAssoc = true;
                    break;
                default:
                    this.template.public = false;
                    this.template.shareWithAssoc = false;
            }

            this.template.calculateUpload();
        }

        createTemplate() {
            this.savePackages().finally(() => {
                this.WorkOrderTemplateService.create(this.appointment.service_request.id, this.template).then(() => {
                    this.toggleCreateTemplate();
                });
            });
        }

        moveLeft(pkg: Package) {
            this.appointment.service_request.packages.forEach((otherPkg) => {
                if (otherPkg.index === pkg.index - 1) {
                    otherPkg.index++;
                }
            });
            pkg.index--;
            this.sortPackages();
        }

        moveRight(pkg: Package) {
            this.appointment.service_request.packages.forEach((otherPkg) => {
                if (otherPkg.index === pkg.index + 1) {
                    otherPkg.index--;
                }
            });
            pkg.index++;
            this.sortPackages();
        }

        moveUp(service: EditedReturnedProduct, pkg: Package) {
            const vm = this;

            (<Product[]>vm.appointment.service_request.packages[pkg.index].services).forEach((otherService: EditedReturnedProduct) => {
                if (otherService.index === service.index - 1){
                    otherService.index++;
                    if (!otherService.is_new) {
                        vm.blockingSaves.push(new Promise<void>((resolve) => {
                            vm.ProductService.updatePackageService(vm.appointment.service_request.id, pkg.id, otherService).then(() => {
                                resolve();
                            });
                        }));
                    }
                }
            });

            service.index--;
            if (!service.is_new) {
                vm.blockingSaves.push(new Promise<void>((resolve) => {
                    vm.ProductService.updatePackageService(vm.appointment.service_request.id, pkg.id, service).then(() => {
                        resolve();
                    });
                }));
            }
            vm.sortProducts(pkg);
        }

        moveDown(service: Product, pkg: Package) {
            const vm = this;

            (<Product[]>vm.appointment.service_request.packages[pkg.index].services).forEach((otherService: EditedReturnedProduct) =>{
                if (otherService.index === service.index + 1){
                    otherService.index--;
                    if (!otherService.is_new) {
                        vm.blockingSaves.push(new Promise<void>((resolve) => {
                            vm.ProductService.updatePackageService(vm.appointment.service_request.id, pkg.id, otherService).then(() => {
                                resolve();
                            });
                        }));
                    }
                }
            });

            service.index++;
            vm.blockingSaves.push(new Promise<void>((resolve) => {
                vm.ProductService.updatePackageService(vm.appointment.service_request.id, pkg.id, service).then(() => {
                    resolve();
                });
            }));
            vm.sortProducts(pkg);
        }

        sortPackages() {
            const vm = this;

            vm.appointment.service_request.packages.sort((a, b) => {
                if (a.index > b.index) return 1; return -1;
            });

            for(let i = 0; i < vm.appointment.service_request.packages.length; i++){
                vm.appointment.service_request.packages[i].index = i;
                vm.sortProducts(vm.appointment.service_request.packages[i]);
            }
        }

        sortProducts(pkg: Package) {
            (<Product[]>pkg.services).sort((a,b) => {
                if (a.index > b.index) return 1; return -1;
            });

            for (let i = 0; i < pkg.services.length; i++){
                pkg.services[i].index = i;
            }

            return pkg;
        }

        orderChanged(event: OrderChangedEvent) {
            const vm = this,
                dest = event.dest,
                src = event.source;

            if(dest.index < src.index) {
                this.moveLeft(src.itemScope.package);
            } else if(src.index < dest.index) {
                this.moveRight(src.itemScope.package);
            }

            vm.savePackages();
        }

        dragMove(itemPosition: ItemPosition, containment: HTMLElement, eventObj: Touch) {
            const vm = this,
                below = eventObj.clientY > vm.$window.innerHeight,
                above = eventObj.clientY < 200;

            if (below || above) {
                if (!this.interval) {
                    this.interval = vm.$window.setInterval(() => {
                        vm.$window.scrollBy(0, below ? 20 : -20);
                    },25);
                }
            } else {
                vm.$window.clearInterval(vm.interval);
                vm.interval = null;
            }
        }

        toggleProductDisplay(): ng.IPromise<any> {
            if (this.isUpdatingProductDisplay) {
                return;
            }

            this.isUpdatingProductDisplay = true;

            return this.ProductService.updateServiceRequest(this.appointment.service_request.id, {
                show_products: !this.appointment.service_request.show_products
            }).then((response) => {
                this.appointment.service_request.show_products = response.data.show_products;
            }).finally(() => {
                this.isUpdatingProductDisplay = false;
            });
        }

        canShowProducts(): boolean {
            return this.appointment.service_request ? this.appointment.service_request.show_products : null;
        }

        isShowingRecommendation() {
            return this.PackageActionsService.selectForAction === 'recommend';
        }

        cancelRecommendation() {
            this.previewRecommendation = false;
            this.previewRecommendationHtml = null;
            this.PackageActionsService.makeAction('recommend', this.appointment.service_request, true);
        }

        toggleRecommendationPreview() {
            if (this.PackageActionsService.selectedPackages.length) {
                this.previewRecommendation = !this.previewRecommendation;
                if (this.previewRecommendation) {
                    this.WorkOrderService.getRecommendationPreview(
                        this.PackageActionsService.selectedPackages.map((p) => p.id),
                        true
                    ).then((resp) => {
                        let parser = new DOMParser(),
                            body = angular.element(parser.parseFromString(resp.data, 'text/html').body);

                        body.find('script').remove();

                        this.previewRecommendationHtml = body.html();
                    });
                } else {
                    this.previewRecommendationHtml = null;
                }
            } else {
                this.previewRecommendation = false;
                this.previewRecommendationHtml = null;
            }
        }

        confirmRecommendations() {
            if (!this.PackageActionsService.selectedPackages.length) {
                // Nothing selected, just close recommendation selection
                this.PackageActionsService.makeAction('recommend', this.appointment.service_request);
                return;
            }

            this.isShowingEmail = true;
        }

        convertToWorkOrder() {
            // noop
        }
    }
}
